import { Component, ViewEncapsulation, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FlexGrid, CellType, GridPanel, CellRangeEventArgs, CellRange } from '@grapecity/wijmo.grid';
import { Menu } from '@grapecity/wijmo.input';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { CodeComboBoxComponent } from '../../..//commons/kymw02/combo-box/code-combo-box/code-combo-box.component';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';

import { KYMW1406Model } from './kymw1406.model';
import { KYMW1406InputModel } from './vo/kymw1406-input.model';
import { KYMW1406OutputModel } from './vo/kymw1406-output.model';
import { KYMW1406GoodsInfoModel } from './vo/kymw1406-goods-info.model';
import { RequestUpdateGoodsInfoModel } from '../kymw1400/vo/request-update-goods-info.model';
import { RequestGetGoodsInfoListModel } from '../kymw1400/vo/request-get-goods-info-list.model';

import { GetGoodsInfoListService } from './api-services/get-goods-info-list.service';
import { UpdateGoodsInfoService } from './api-services/update-goods-info.service';
import * as wjcCore from '@grapecity/wijmo';
import { GetCrossMultiService } from './api-services/get-cross-multi.service';

/**
 * 商品情報画面を管理するクラス
 *
 * @export KYMW1406Component
 * @class KYMW1406Component
 */
@Component({
  selector: 'app-kymw1406',
  templateUrl: 'kymw1406.component.html',
  styleUrls: ['kymw1406.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1406Component extends PlessViewHelperSub implements OnInit {
  @ViewChild('dtg_GoodsInfo', { static: true }) dtg_GoodsInfo: FlexGrid;
  @ViewChild('dtg_GoodsAttribute', { static: true }) dtg_GoodsAttribute: FlexGrid;
  @ViewChild('cmb_KomaPatternDiv', { static: true }) cmb_KomaPatternDiv: CodeComboBoxComponent;
  @ViewChild('cmb_ListingPatternID', { static: true }) cmb_ListingPatternID: CodeComboBoxComponent;
  @ViewChild('cmb_ListingGoodsName', { static: true }) cmb_ListingGoodsName: ElementRef;

  /**
   * 受渡情報ＶＯ
   */
  public inputVO: KYMW1406InputModel = null;

  public closeFunction: Function = null;
  public setKYMW1406Parameter: Function = null;

  public kymw1406Model: KYMW1406Model = new KYMW1406Model();

  // コンテキストメニュー
  public contextMenu: Menu = null;

  private cellEditFlag = Boolean(false);

  // 初期フォーカス設定フラグ
  private initFocusFlag = Boolean(true);

   iconQuestion = faQuestionCircle;

  public readonly EDIT_MODE_EDITABLE: string = String('0');
  public readonly EDIT_MODE_READONLY: string = String('1');

  /**
   *Creates an instance of KYMW1406Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @param {GetGoodsInfoListService} getGoodsInfoListService
   * @param {UpdateGoodsInfoService} updateGoodsInfoService
   * @memberof KYMW1406Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private elementRef: ElementRef,
    private kymw00Model: KYMW00Model,
    private getGoodsInfoListService: GetGoodsInfoListService,
    private updateGoodsInfoService: UpdateGoodsInfoService,
    private getCrossMultiService: GetCrossMultiService
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW1406Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1406';
    // モデルクラスへ自コンポーネントを連携
    this.kymw1406Model.kymw1406Component = this;
    // InputVOをマネージにセット
    this.kymw1406Model.komaID = this.inputVO.komaID;
    this.kymw1406Model.editMode = this.inputVO.editMode;
    this.kymw1406Model.orderGoodsFlg = this.inputVO.orderGoodsFlg;
    if (this.inputVO.komaID !== 0 && this.inputVO.pcodeList.length > 0) {
      // 商品情報取得要求をサーバに送信
      const requestGetGoodsInfoListVO = this.createRequestGetGoodsInfoListVO();
      this.getGoodsInfoListService.execute(this.kymw1406Model, requestGetGoodsInfoListVO, () => {
        this.activeControl();
      });
    } else {
      this.kymw1406Model.goodsInfoList = new Array<any>();
      this.kymw1406Model.listingGoodsNameList = new Array<any>();
      this.kymw1406Model.komaComment = '';
      this.kymw1406Model.valueKomaComment = '';
      this.kymw1406Model.clearCrossAndMultiSetting();

      this.showGoodsAttribute(0);
      this.activeControl();
    }

    // グリッド初期処理
    this.gridInit();

    // コンテキストメニュー設定
    this.setContextMenu();

    if (this.initFocusFlag) {
      this.dtg_GoodsInfo.hostElement.focus();
      this.initFocusFlag = false;
    }
  }

  /**
   * グリッド初期処理
   *
   * @private
   * @memberof KYMW1406Component
   */
  private gridInit() {
    // 商品一覧
    // マウスによるセル選択時のみセルを編集モードにする
    this.dtg_GoodsInfo.hostElement.addEventListener('mousedown', (e: MouseEvent) => {
      this.cellEditFlag = true;
    });

    // 選択行変更時処理
    this.dtg_GoodsInfo.selectionChanged.addHandler((s: FlexGrid, e: CellRangeEventArgs) => {
      if (this.cellEditFlag) {
        setTimeout(function () {
          s.startEditing(false);
        });
        this.cellEditFlag = false;
      }
      this.eventGoodsInfo_CLICKHandler(e);
    });

    // 編集完了時
    this.dtg_GoodsInfo.cellEditEnded.addHandler((s: FlexGrid, e: CellRangeEventArgs) => {
      // 入力値を反映
      // ESCキーによるキャンセル時はe.dataがundefined、DeleteキーやBackSpaceキー押下時はe.dataが
      // KeyboardEventになるので、入力完了時のみ対応する
      if (typeof e.data === 'string') {
        s.selectedItems[0].OrderNumSeqNo = e.data;
      }
    });

    // 編集終了時
    this.dtg_GoodsInfo.cellEditEnding.addHandler((s: FlexGrid, e: CellRangeEventArgs) => {
      if (e.cancel && e.cancel === true) {
        // ESCキー押下時は値を元に戻す
        s.setCellData(e.row, e.col, s.activeEditor.value);
      }
    });


    // 商品属性情報
    // グリッドデータ設定時、行未選択
    this.dtg_GoodsAttribute.itemsSourceChanged.addHandler((s: FlexGrid, e: CellRangeEventArgs) => {
      this.dtg_GoodsAttribute.select(-1, -1);
    });
  }

  /**
   * コンテキストメニューを追加
   *
   * @memberof KYMW1406Component
   */
  setContextMenu(): void {
    this.contextMenu = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          { header: '上へ', caption: '上へ', cmd: 'ToDown', enabled: false },
          { header: '下へ', caption: '下へ', cmd: 'ToUp', enabled: false },
          { header: '行削除', caption: '行削除', cmd: 'DeleteRow', enabled: false },
        ],
        command: this.getFormatMenuCommand(),
        // イベント設定
        itemClicked: (s, e) => {
          switch (this.contextMenu.selectedValue) {
            case 'ToDown':
              this.eventUp_CONTEXTCLICKHandler(e);
              break;
            case 'ToUp':
              this.eventDown_CONTEXTCLICKHandler(e);
              break;
            case 'DeleteRow':
              this.eventDelete_CONTEXTCLICKHandler(e);
              break;
          }
        }
      }
    );

    // 右クリック押下時 コンテキストメニュー表示処理
    this.dtg_GoodsInfo.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.contextMenu !== undefined) {
        this.eventContextMenu_Handler(this.dtg_GoodsInfo.selection.row);
        this.contextMenu.show(e);
      }
    });

    // 活性制御用のリストに項目を追加
    this.initForcedEnabledForContextMenuItemByScreenMode(this.contextMenu.itemsSource[0], 'none');
    this.initForcedEnabledForContextMenuItemByScreenMode(this.contextMenu.itemsSource[1], 'none');
    this.initForcedEnabledForContextMenuItemByScreenMode(this.contextMenu.itemsSource[2], 'none');
  }

  /**
   * メニュー項目活性・非活性制御
   *
   * @returns {*}
   * @memberof KYMW1406Component
   */
  public getFormatMenuCommand(): any {
    return {
      canExecuteCommand: (param) => {
        // 各項目の活性制御
        return (param.enabled === false) ? false : true;
      }
    };
  }

  /**
   * パラメータ設定処理
   *
   * @param {KYMW1406InputModel} inputVO
   * @memberof KYMW1406Component
   */
  public inputParameterSetting(): void {
    this.inputVO = this.iInputVOArray;
  }

  /**
   * パラメータを受け取り初期処理を実行する
   *
   * @param {KYMW1406InputModel} inputVO
   * @memberof KYMW1406Component
   */
  public setInputVO(inputVO: KYMW1406InputModel): void {
    this.inputVO = inputVO;
    // 初期処理を呼び出す
    this.ngOnInit();
  }

  /**
   * 商品一覧をクリックした時に呼び出されるメソッド。
   *
   * @private
   * @param {*} event コールバック・イベントへの参照
   * @memberof KYMW1406Component
   */
  public eventGoodsInfo_CLICKHandler(event: any): void {
    // // 選択行を取得する
    const rowIndex: number = this.dtg_GoodsInfo.selection.row;
    // 選択行の「商品属性情報」を表示、コンテキストメニュー(上へ、下へ)の活性・非活性の制御
    this.showGoodsAttribute(rowIndex);
  }

  /**
   * 設定ボタンをクリックした時に呼び出されるメソッド。
   *
   * @returns {void}
   * @memberof KYMW1406Component
   */
  public eventRegist_CLICKHandler(): void {
    if (this.dtg_GoodsInfo.itemsSource != null) {
      const goodsInfoList: Array<any> = this.dtg_GoodsInfo.collectionView.items;
      for (let i = Number(0); i < goodsInfoList.length; i++) {
        // Seq.NOが未設定の場合、エラー処理
        if (goodsInfoList[i].OrderNumSeqNo == null ||
          PlessViewUtilsSub.trim(goodsInfoList[i].OrderNumSeqNo) === '' ||
          PlessViewUtilsSub.trim(goodsInfoList[i].OrderNumSeqNo) === 'null') {
          // エラーメッセージを表示して終了
          this.dialogService.openAlertGetMessage('E0110', ['Seq.NO']);
          const index: number = this.dtg_GoodsInfo.selection.row;
          this.kymw1406Model.selectedListingPatternIndex = index;
          return;
        }
      }

      // サーバ送信用データ作成
      const array: Array<any> = new Array<any>();
      let goodsInfoVO: any;
      const updateGoodsInfoVO: RequestUpdateGoodsInfoModel = new RequestUpdateGoodsInfoModel();
      // Ｐコードの数分ループ
      for (let j = Number(0); j < goodsInfoList.length; j++) {
        goodsInfoVO = new KYMW1406GoodsInfoModel();
        goodsInfoVO.orderNumSeqNo = Number(goodsInfoList[j].OrderNumSeqNo);
        goodsInfoVO.pCode = goodsInfoList[j].PCode;
        goodsInfoVO.priority = j + 1;
        array.push(goodsInfoVO);
      }
      updateGoodsInfoVO.goodsInfoList = array;
      updateGoodsInfoVO.komaComment = this.kymw1406Model.komaComment;
      updateGoodsInfoVO.komaID = this.inputVO.komaID;
      updateGoodsInfoVO.valueKomaComment = this.kymw1406Model.valueKomaComment;
      updateGoodsInfoVO.komaPatternDiv = this.cmb_KomaPatternDiv.selectedCodeValue;
      updateGoodsInfoVO.listingPatternID = this.cmb_ListingPatternID.selectedCodeValue;
      updateGoodsInfoVO.listingPCode = this.kymw1406Model.listingGoodsName;
      updateGoodsInfoVO.orderGoodsFlg = this.kymw1406Model.orderGoodsFlg;
      updateGoodsInfoVO.pcodeList = this.inputVO.pcodeList;
      updateGoodsInfoVO.orderGoodsFlgKoma = this.inputVO.orderGoodsFlgKoma;
      updateGoodsInfoVO.orderCode = this.inputVO.orderCode;
      updateGoodsInfoVO.mediumType = this.inputVO.mediumType;
      updateGoodsInfoVO.crossCode = this.kymw1406Model.crossSetting.crossCode;
      updateGoodsInfoVO.crossGoodsExplanation = this.kymw1406Model.crossSetting.goodsExplanation;
      updateGoodsInfoVO.crossCatchCopy = this.kymw1406Model.crossSetting.catchCopy;
      updateGoodsInfoVO.multiCode = this.kymw1406Model.multiSetting.multiCode;
      updateGoodsInfoVO.multiGoodsExplanation = this.kymw1406Model.multiSetting.goodsExplanation;
      updateGoodsInfoVO.multiCatchCopy = this.kymw1406Model.multiSetting.catchCopy;
      // サーバ送信
      const vo = updateGoodsInfoVO;
      this.updateGoodsInfoService.execute(this.kymw1406Model, vo, () => {
        this.getCrossMultiService.execute(this.kymw1406Model);
      });
    }
  }

  /**
   * コンテキストメニューの上へをクリックした時に呼び出されるメソッド。
   *
   * @private
   * @param {Event} event コールバック・イベントへの参照
   * @memberof KYMW1406Component
   */
  public eventUp_CONTEXTCLICKHandler(event: Event): void {
    // 行を選択しているか
    if (this.dtg_GoodsInfo.selectedItems != null) {
      // 選択行の取得
      const rowIndex: number = this.dtg_GoodsInfo.selection.row;
      // 選択行が先頭でないか
      if (rowIndex !== 0) {
        // 行の入れ替え用
        const workArray: Array<any> = new Array<any>();
        // 行の入れ替え（配列を入れ替える）
        for (let i = Number(0); i < this.kymw1406Model.goodsInfoList.length; i++) {
          if (i === rowIndex - 1) {
            // アレイの変更 +1番目
            workArray.push(this.dtg_GoodsInfo.collectionView.items[i + 1]);
          } else if (i === rowIndex) {
            // アレイの変更 -1番目
            workArray.push(this.dtg_GoodsInfo.collectionView.items[i - 1]);
          } else {
            workArray.push(this.dtg_GoodsInfo.collectionView.items[i]);
          }
        }
        // 行の入れ替えを反映
        this.kymw1406Model.goodsInfoList = workArray;
        setTimeout(() => {
          this.dtg_GoodsInfo.selection = new CellRange(-1, -1, -1, -1);
        });

        // 商品一覧が2件以上の場合、商品一覧と同じ商品の組み合わせ・優先順のクロス設定とマルチ設定を取得する
        if (this.kymw1406Model.goodsInfoList.length >= 2) {
          this.getCrossMultiService.execute(this.kymw1406Model);
        }
      }
    }
  }

  /**
   * コンテキストメニューの下へをクリックした時に呼び出されるメソッド。
   *
   * @private
   * @param {Event} event コールバック・イベントへの参照
   * @memberof KYMW1406Component
   */
  public eventDown_CONTEXTCLICKHandler(event: Event): void {
    // 行を選択しているか
    if (this.dtg_GoodsInfo.selectedItems != null) {
      // リストの件数を取得
      const listCount: number = this.kymw1406Model.goodsInfoList.length;
      // 選択行の取得
      const rowIndex: number = this.dtg_GoodsInfo.selection.row;
      // 選択行が最後でないか
      if (listCount !== rowIndex) {
        // 行の入れ替え用
        const workArray: Array<any> = new Array<any>();
        // 行の入れ替え（配列を入れ替える）
        for (let i = Number(0); i < this.kymw1406Model.goodsInfoList.length; i++) {
          if (i === rowIndex) {
            // アレイの変更 +1番目
            workArray.push(this.dtg_GoodsInfo.collectionView.items[i + 1]);
          } else if (i === rowIndex + 1) {
            // アレイの変更 -1番目
            workArray.push(this.dtg_GoodsInfo.collectionView.items[i - 1]);
          } else {
            workArray.push(this.dtg_GoodsInfo.collectionView.items[i]);
          }
        }
        // 行の入れ替えを反映
        this.kymw1406Model.goodsInfoList = workArray;
        setTimeout(() => {
          this.dtg_GoodsInfo.selection = new CellRange(-1, -1, -1, -1);
        });

        // 商品一覧が2件以上の場合、商品一覧と同じ商品の組み合わせ・優先順のクロス設定とマルチ設定を取得する
        if (this.kymw1406Model.goodsInfoList.length >= 2) {
          this.getCrossMultiService.execute(this.kymw1406Model);
        }
      }
    }
  }

  /**
   * コンテキストメニューの削除をクリックした時に呼び出されるメソッド。
   *
   * @private
   * @param {Event} event コールバック・イベントへの参照
   * @memberof KYMW1406Component
   */
  public eventDelete_CONTEXTCLICKHandler(event: Event): void {
    // 行を選択しているか
    if (this.dtg_GoodsInfo.selectedItems != null) {
      // 選択行の取得

      // 画面で選択した行データと同じデータのインデックス番号をpageTemplateListから取得
      // 画面のグリッドをソートすると行番号をそのまま使用することができなくなるため
      const rowIndex: number = this.kymw1406Model.goodsInfoList.findIndex(
        page => page.OrderNumSeqNo === this.dtg_GoodsInfo.selectedItems[0].OrderNumSeqNo);

      const sortDirection = this.dtg_GoodsInfo.collectionView.sortDescriptions.map(function (sortDesc) {
        return { property: sortDesc.property, ascending: sortDesc.ascending };
      });

      // 行の入れ替え用
      const workArray: Array<any> = new Array<any>();
      // 行の入れ替え（対象の配列を削除）
      for (let i = Number(0); i < this.kymw1406Model.goodsInfoList.length; i++) {
        if (i !== rowIndex) {
          workArray.push(this.dtg_GoodsInfo.itemsSource[i]);
        }
      }
      // 行の入れ替えを反映
      this.kymw1406Model.goodsInfoList = workArray;
      this.kymw1406Model.updateFlg = 2;						// 更新フラグ（2:削除）

      setTimeout(() => {
        this.dtg_GoodsInfo.selection = new CellRange(-1, -1, -1, -1);

        this.dtg_GoodsInfo.collectionView.sortDescriptions.clear();
        for (let i = 0; i < sortDirection.length; i++) {
          const sortDesc = sortDirection[i];
          this.dtg_GoodsInfo.collectionView.sortDescriptions.push(
            new wjcCore.SortDescription(sortDesc.property, sortDesc.ascending)
          );
        }
      });
      this.showGoodsAttribute(-1);

      // 商品一覧が2件以上の場合、商品一覧と同じ商品の組み合わせ・優先順のクロス設定とマルチ設定を取得する
      if (this.kymw1406Model.goodsInfoList.length >= 2) {
        this.getCrossMultiService.execute(this.kymw1406Model);
      } else {
        // コマに掲載される商品が1件の場合、クロス設定とマルチ設定自体存在しない
        this.kymw1406Model.clearCrossAndMultiSetting();
        this.kymw1406Model.setDisabledCross(true);
        this.kymw1406Model.setDisabledMulti(true);
      }
    }
  }

  /**
   * 選択行の「商品属性情報」を表示する
   * コンテキストメニューの活性・非活性の制御
   *
   * @param {number} index 選択行
   * @memberof KYMW1406Component
   */
  public showGoodsAttribute(index: number): void {
    const showArray: Array<any> = new Array<any>();
    // コマＩＤが設定されているか
    if (this.inputVO.komaID !== 0 && index !== -1 && this.inputVO.pcodeList.length > 0) {
      // DataGridの初期選択
      showArray.push({ lbl: 'バイヤーコメント', data: this.kymw1406Model.goodsInfoList[index].BuyerComment });
      showArray.push({ lbl: '商品説明文', data: this.kymw1406Model.goodsInfoList[index].GoodsExplanation });
      showArray.push({ lbl: 'キャッチコピー', data: this.kymw1406Model.goodsInfoList[index].CatchCopy });
      showArray.push({ lbl: 'おすすめコメント', data: this.kymw1406Model.goodsInfoList[index].RecommendComment });
      showArray.push({ lbl: '便利情報（囲み）', data: this.kymw1406Model.goodsInfoList[index].ConvenienceInfoSiege });
      showArray.push({ lbl: '便利情報（商品構成内容）', data: this.kymw1406Model.goodsInfoList[index].ConvenienceInfoGoods });
      showArray.push({ lbl: '便利情報（その他）', data: this.kymw1406Model.goodsInfoList[index].ConvenienceInfoOther });
      showArray.push({ lbl: '便利情報（eフレンズ）', data: this.kymw1406Model.goodsInfoList[index].ConvenienceInfoEFriend });
      showArray.push({ lbl: '便利情報（サイズ他）', data: this.kymw1406Model.goodsInfoList[index].ConvenienceInfoSize });
      showArray.push({ lbl: '便利情報（月齢情報）', data: this.kymw1406Model.goodsInfoList[index].AgeInformation });
      showArray.push({ lbl: '人気商品情報', data: this.kymw1406Model.goodsInfoList[index].PopularProductInformation });
      showArray.push({ lbl: '健康管理情報', data: this.kymw1406Model.goodsInfoList[index].HealthCareInformation });
      showArray.push({ lbl: '成分情報', data: this.kymw1406Model.goodsInfoList[index].IngredientInformation });
      showArray.push({ lbl: '吸水量', data: this.kymw1406Model.goodsInfoList[index].WaterAbsorption });
      showArray.push({ lbl: '調理時間の目安', data: this.kymw1406Model.goodsInfoList[index].MealKitEstimatedCookingTime });
      showArray.push({ lbl: '○人前情報', data: this.kymw1406Model.goodsInfoList[index].MealKitPortionInformation });
      showArray.push({ lbl: '材料', data: this.kymw1406Model.goodsInfoList[index].MealKitIngredients });
      showArray.push({ lbl: 'ご家庭で用意いただくもの', data: this.kymw1406Model.goodsInfoList[index].MealKitItemsPreparedHome });
      showArray.push({ lbl: '取扱注意', data: this.kymw1406Model.goodsInfoList[index].HandleWithCare });

      this.kymw1406Model.goodsDetailList = showArray;

    } else {
      showArray.push({ lbl: 'バイヤーコメント', data: '' });
      showArray.push({ lbl: '商品説明文', data: '' });
      showArray.push({ lbl: 'キャッチコピー', data: '' });
      showArray.push({ lbl: 'おすすめコメント', data: '' });
      showArray.push({ lbl: '便利情報（囲み）', data: '' });
      showArray.push({ lbl: '便利情報（商品構成内容）', data: '' });
      showArray.push({ lbl: '便利情報（その他）', data: '' });
      showArray.push({ lbl: '便利情報（eフレンズ）', data: '' });
      showArray.push({ lbl: '便利情報（サイズ他）', data: '' });
      showArray.push({ lbl: '便利情報（月齢情報）', data: '' });
      showArray.push({ lbl: '人気商品情報', data: '' });
      showArray.push({ lbl: '健康管理情報', data: '' });
      showArray.push({ lbl: '成分情報', data: '' });
      showArray.push({ lbl: '吸水量', data: '' });
      showArray.push({ lbl: '調理時間の目安', data: '' });
      showArray.push({ lbl: '○人前情報', data: '' });
      showArray.push({ lbl: '材料', data: '' });
      showArray.push({ lbl: 'ご家庭で用意いただくもの', data: '' });
      showArray.push({ lbl: '取扱注意', data: '' });

      this.kymw1406Model.goodsDetailList = showArray;
    }
  }

  /**
   * コンボボックスの初期表示
   */
  public showComboBox(): void {
    if (this.inputVO.komaID !== 0 || this.inputVO.editMode !== this.EDIT_MODE_EDITABLE) {
      this.cmb_KomaPatternDiv.setCodeValue(this.kymw1406Model.komaInfoList[0].KomaPatternDiv);
      this.cmb_ListingPatternID.setCodeValue(this.kymw1406Model.listingInfoList[0].ListingPatternID);
      for (let i = Number(0); i < this.kymw1406Model.listingGoodsNameList.length; i++) {
        if (this.kymw1406Model.listingGoodsNameList[i].code === this.kymw1406Model.listingInfoList[0].ListingPCode) {
          this.kymw1406Model.listingGoodsName = this.kymw1406Model.listingGoodsNameList[i].code;
        }
      }
    }
  }

  /**
   * 活性・非活性制御
   *
   * @memberof KYMW1406Component
   */
  public activeControl(): void {
    // 閲覧モードおよびコマＩＤ未設定の場合
    if (this.inputVO.editMode === this.EDIT_MODE_READONLY || this.inputVO.komaID === 0 || this.inputVO.pcodeList.length === 0) {
      // 設定ボタンの非活性化
      this.kymw1406Model.disabledRegist = true;
      this.kymw1406Model.disabledGoodsInfo = true;
      this.kymw1406Model.disabledKomaComment = true;
      this.kymw1406Model.disabledKomaPatternDiv = true;
      this.kymw1406Model.disabledValueKomaComment = true;
      this.kymw1406Model.disabledListingPatternID = true;
      this.kymw1406Model.disabledListingGoodsName = true;
      this.kymw1406Model.disabledCrossGoodsExplanation = true;
      this.kymw1406Model.disabledCrossCatchCopy = true;
      this.kymw1406Model.disabledMultiGoodsExplanation = true;
      this.kymw1406Model.disabledMultiCatchCopy = true;
    } else {
      // 設定ボタンの非活性化
      this.kymw1406Model.disabledRegist = false;
      this.kymw1406Model.disabledGoodsInfo = false;
      this.kymw1406Model.disabledKomaComment = false;
      this.kymw1406Model.disabledKomaPatternDiv = false;
      this.kymw1406Model.disabledValueKomaComment = false;
      this.kymw1406Model.disabledListingPatternID = false;
      this.kymw1406Model.disabledListingGoodsName = false;
      this.kymw1406Model.disabledCrossGoodsExplanation = false;
      this.kymw1406Model.disabledCrossCatchCopy = false;
      this.kymw1406Model.disabledMultiGoodsExplanation = false;
      this.kymw1406Model.disabledMultiCatchCopy = false;
    }
    // クロスコードが無い場合、クロス設定は登録できない
    if (!this.kymw1406Model.crossSetting.crossCode) {
      this.kymw1406Model.setDisabledCross(true);
    }
    // マルチコードがない場合、マルチ設定は登録できない
    if (!this.kymw1406Model.multiSetting.multiCode) {
      this.kymw1406Model.setDisabledMulti(true);
    }
  }

  /**
   * 商品情報取得VO設定
   *
   * @private
   * @returns {RequestGetGoodsInfoListModel}
   * @memberof KYMW1406Component
   */
  private createRequestGetGoodsInfoListVO(): RequestGetGoodsInfoListModel {
    const vo: RequestGetGoodsInfoListModel = new RequestGetGoodsInfoListModel();

    // コマＩＤ
    vo.komaID = this.inputVO.komaID;
    // 注文商品区分
    vo.orderGoodsFlg = this.inputVO.orderGoodsFlg;

    return vo;
  }

  /**
   * ｢コマ割｣画面の再表示処理を行う。
   *
   * @memberof KYMW1406Component
   */
  public refreshKYMW1400(): void {
    const outputVO: KYMW1406OutputModel = new KYMW1406OutputModel();
    outputVO.updateFlg = this.kymw1406Model.updateFlg;
    this.parent.setKYMW1406Parameter(outputVO);
  }


  /**
   * コンテキストメニュー項目活性・非活性制御
   *
   * @private
   * @returns
   * @memberof KYMW1406Component
   */
  public eventContextMenu_Handler(index: number): any {
    // コンテキストメニュー(上へ、下へ)の活性・非活性の制御
    for (let i = Number(0); i < this.contextMenu.itemsSource.length; i++) {
      // すべて活性
      this.contextMenu.itemsSource[i].enabled = true;
    }
    if (index === -1 || index === 0) {
      // 上への非活性化
      this.contextMenu.itemsSource[0].enabled = false;
    }
    if (index === -1 || index === this.kymw1406Model.goodsInfoList.length - 1) {
      // 下への非活性化
      this.contextMenu.itemsSource[1].enabled = false;
    }

    if (index === -1 || this.inputVO.editMode === this.EDIT_MODE_READONLY) {
      // 削除非活性
      this.contextMenu.itemsSource[2].enabled = false;
    }
  }
}
